// File: src/components/NewsletterFooterSignup.jsx
// Double opt-in signup for The Scope Weekly, shown in the site footer.
// Hidden until NEWSLETTER_FOOTER_SIGNUP is turned on in src/config/contentAutomation.js
// (and the server also refuses signups until siteConfig/newsletter.signupEnabled is true).
import React, { useState } from "react";
import { httpsCallable } from "firebase/functions";
import { getFunctionsClient } from "../firebaseConfig";
import { NEWSLETTER_FOOTER_SIGNUP } from "../config/contentAutomation";

export default function NewsletterFooterSignup() {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState({ status: "idle", message: "" });

  if (!NEWSLETTER_FOOTER_SIGNUP) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) {
      setState({ status: "error", message: "Please tick the box so we know you want the newsletter." });
      return;
    }
    setState({ status: "loading", message: "" });
    try {
      const fn = httpsCallable(getFunctionsClient(), "newsletterOptIn");
      const { data } = await fn({ email: email.trim(), consent: true, source: "site_footer" });
      setState({ status: data.ok ? "done" : "error", message: data.message });
      if (data.ok) setEmail("");
    } catch (err) {
      setState({ status: "error", message: err.message || "Something went wrong. Please try again." });
    }
  };

  return (
    <form onSubmit={submit} className="w-full max-w-md text-left" aria-label="Subscribe to The Scope Weekly">
      <p className="text-xs font-black uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-1">The Scope Weekly</p>
      <p className="text-sm text-slate-600 dark:text-slate-300 mb-2">Every two weeks: one new article and one PMP tip. Free, and you can leave any time.</p>
      <div className="flex gap-2">
        <label htmlFor="footer-newsletter-email" className="sr-only">Email address</label>
        <input
          id="footer-newsletter-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="flex-1 min-w-0 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-3 py-2 text-sm text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-[#00BFA5]"
        />
        <button type="submit" disabled={state.status === "loading"} className="rounded-lg bg-[#00BFA5] px-4 py-2 text-sm font-bold text-[#002060] hover:brightness-95 disabled:opacity-60">
          {state.status === "loading" ? "Sending..." : "Subscribe"}
        </button>
      </div>
      <label className="mt-2 flex items-start gap-2 text-xs text-slate-500 dark:text-slate-400">
        <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5" />
        <span>Yes, email me The Scope Weekly. I will confirm by email and can unsubscribe at any time. See the <a href="/privacy" className="underline">Privacy Policy</a>.</span>
      </label>
      {state.message && (
        <p role="status" className={`mt-2 text-xs ${state.status === "error" ? "text-red-600 dark:text-red-400" : "text-emerald-700 dark:text-emerald-400"}`}>{state.message}</p>
      )}
    </form>
  );
}
